import { FC, useState, useTransition } from "react";
import { Nav } from "react-bootstrap";
import { IconButton, Badge } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NotificationBellIcon from "@/assets/icons/side-menu/notification-bell-icon";
import { useNotificationsList } from "@/modules/notification-center/hooks/notifications-list.hook";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { NotificationsLayover } from "./notifications-layover";

interface NotificationBellProps {
  variant?: "icon" | "text";
  href: string;
}

const NotificationBell: FC<NotificationBellProps> = ({
  variant = "icon",
  href,
}) => {
  const navigate = useNavigate();
  const { count: unreadCount } = useNotificationsList({
    params: { read: false },
  });

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [, startTransition] = useTransition();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    const target = event.currentTarget;
    startTransition(() => {
      setAnchorEl(target);
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(href);
  };

  if (variant === "text") {
    return <Nav.Link onClick={handleNavigation}>Notifications</Nav.Link>;
  }

  return (
    <>
      <IconButton
        data-testid="notification-bell"
        onClick={handleOpen}
        sx={{
          color: "white",
          width: 40,
          height: 40,
          borderRadius: "50%",
        }}
      >
        <Badge
          badgeContent={unreadCount}
          overlap="circular"
          slotProps={{
            badge: {
              "data-testid": "notification-bell-unread-count",
            } as React.HTMLAttributes<HTMLSpanElement>,
          }}
          sx={{
            "& .MuiBadge-badge": {
              top: 6,
              right: 6,
              minWidth: 16,
              height: 16,
              padding: "0 4px",
              borderRadius: "50%",
              backgroundColor: nawyTheme.nawy.colors.semantic.indicator.orange,
              ...nawyTheme.nawy.typography.english.variants.body.xs.semibold,
              color: nawyTheme.nawy.colors.semantic.text.onColor,
            },
          }}
        >
          <NotificationBellIcon />
        </Badge>
      </IconButton>

      <NotificationsLayover
        anchorEl={anchorEl}
        handleCloseNotificationBell={handleClose}
        unreadCount={unreadCount}
      />
    </>
  );
};

export default NotificationBell;
